import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import home from './components/home/home'
import team from './components/team/team'
import websiteDevelopment from './components/website-development/website-development'
import frontEndOutsourcing from './components/front-end-outsourcing/front-end-outsourcing'
// import services from './components/services/services'
import technologies from './components/technologies/technologies'
import projects from './components/projects/projects'
import contactus from './components/contactus/contactus'
import careers from './components/careers/careers'

Vue.use(VueRouter);

const router = new VueRouter({
	linkActiveClass: 'active',
	routes: [
		{ path: '/', redirect: '/home' },
		{ path: '/home', name: 'home', component: home, meta: { linkText: 'Home' } },
		{ path: '/website-development', name: 'websiteDevelopment', component: websiteDevelopment, meta: { linkText: 'Website Development' } },
		{ path: '/front-end-outsourcing', name: 'frontEndOutsourcing', component: frontEndOutsourcing, meta: { linkText: 'Front End Outsourcing' } },
		{ path: '/team', name: 'team', component: team, meta: { linkText: 'Team' } },
		// { path: '/services', name: 'services', component: services, meta: { linkText: 'Our Services' } },
		{ path: '/technologies', name: 'technologies', component: technologies, meta: { linkText: 'Technologies' } },
		{ path: '/projects', name: 'projects', component: projects, meta: { linkText: 'Projects' } },
		{ path: '/careers', name: 'careers', component: careers, meta: { linkText: 'Careers' } },
		{ path: '/contactus', name: 'contactus', component: contactus, meta: { linkText: 'Contact Us' } }
	]
});

export default router



// WEBPACK FOOTER //
// ./src/router.js